export type MFEStatusDesc = {
    loaded: boolean
    message: string
    error?: any
}

export type MFEIdentifier = {
    moduleFederatedName: string;
    mfExposedName: string;
};

export const getFullExposedName = (id: MFEIdentifier): string => {
    return `${id.moduleFederatedName}/${id.mfExposedName}`;
};
